export const APPLY = {
  GUARANTEE: 'GUARANTEE',
  CLEAR: 'CLEAR',
  SET_EDIT_ID: 'SET_EDIT_ID',
}
